import React, { memo } from 'react';
import { Text } from '@beef/ui-kit';

const SharedZoneNewTitle = memo(({ title }) => <Text size="size1-b">{title}</Text>);

export { SharedZoneNewTitle };
